<template>
  <el-drawer
    :title="formTitle"
    :visible.sync="formDrawerStatus"
    direction="rtl"
    :before-close="cancelEditBpmnForm"
    @close="closedEditProcess"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div class="from-content">
      <scroll-bar>
        <!-- 审批 -->
        <approval
          v-if="isShowApprovalNode()"
          ref="Approver"
          :currentEditNode="currentEditNode"
          :moddle="moddle"
          :notFindApproverOptions="notFindApproverEnum"
        ></approval>

        <!-- 条件 -->
        <condition
          v-else-if="isShowNode('SequenceFlow')"
          ref="SequenceFlow"
          :currentEditNode="currentEditNode"
          :coditionsSum="coditionsSum"
          :moddle="moddle"
          :currentBpmnEl="currentBpmnEl"
          :conditonPriority="currentConditonPriority"
          :conditions="conditions"
          :rootElement="rootElement"
          :eventBus="eventBus"
          :modeling="modeling"
          :handleCancel="handleCancel"
        ></condition>

        <!-- 抄送 -->
        <notifier
          v-else-if="isShowNode('Copy')"
          ref="Copy"
          :currentEditNode="currentEditNode"
          :moddle="moddle"
        ></notifier>

        <div v-else></div>

        <!-- 财务 -->
        <!-- <finance
        v-if="isShowNode('Finance')"
        ref="Finance"
        :currentEditNode="currentEditNode"
        :moddle="moddle"
        ></finance>-->

        <!-- 出纳 -->
      </scroll-bar>
    </div>

    <!-- 操作 -->
    <div class="approve-drawer_footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="saveBpmnNodeData()">保 存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import ScrollBar from "@/components/Scrollbar/Scrollbar.vue";

import Approval from "./approval/approval";
import Condition from "./condition/condition";
import Finance from "./finance/finance";
import Notifier from "./notifier/notifier";

import { initNodeForm } from "./approval/approvalConfig";

import { mapState, mapMutations } from "vuex";

export default {
  components: {
    Condition,
    Approval,
    Finance,
    Notifier,
    ScrollBar,
  },

  // provide: {
  //   moddle: moddle,
  //   modeling: modeling
  // },

  props: {
    moddle: {
      type: Object,
    },
    conditions: {
      type: Array,
    },
    modeling: {
      type: Object,
    },
    eventBus: {
      type: Object,
    },
  },

  computed: {
    ...mapState({
      // 解构
      bpmnNodeInfo: (state) => state.process.nodeInfo,

      bpmnNodeVisible: (state) => state.process.nodeVisible,
    }),

    formTitle() {
      if (this.currentEditNode) {
        return this.currentEditNode.name;
      } else {
        return "";
      }
    },
  },

  data() {
    return {
      formDrawerStatus: false,
      defaultEmployees: [],
      currentEditNode: null,
      currentBpmnEl: null,
      coditionsSum: 0,
      rootElement: null,
      currentConditonPriority: 0,
      notFindApproverEnum: [],
      allRoles: [],
    };
  },
  watch: {
    currentEditNode: {
      deep: true,
      handler(newVal, oldVal) {
        // this.setFormInitialData(newVal.id);
      },
    },
  },

  created() {
    this.setNotFindApproverEnum("notFindApprover");
    this.setAllRoles();
  },
  methods: {
    cancelEditBpmnForm(done) {
      this.handleCancel();
    },

    handleCancel() {
      let document = this.currentEditNode.documentation;

      if (!document && !this.isShowNode("SequenceFlow")) {
        return this.saveBpmnNodeData();
      }

      this.formDrawerStatus = false;
    },

    // 销毁 Form 表单
    closedEditProcess() {
      this.$nextTick(() => {
        this.currentEditNode = {};
      });
    },

    setNotFindApproverEnum(enumCode) {
      this.$api.enumTypeCode(enumCode).then((res) => {
        this.notFindApproverEnum = res;
      });
    },

    // 查询角色
    setAllRoles() {
      this.$api.getRoles({ getAll: true }).then((res) => {
        this.allRoles = res;
      });
    },

    getRolesByName(name) {
      let roles = [];
      this.allRoles.forEach((item) => {
        roles.push(...item.roleDOS);
      });
      let { id, roleName } = roles.find((item) => item.roleName === name);
      return {
        id,
        roleName,
      };
    },

    /**
     * 初始化编辑页面数据
     *
     */
    setInitialFormData(el) {
      this.currentEditNode = el.businessObject;
      this.currentBpmnEl = el;

      this.currentConditonPriority = this.getCurrentConditonPriority(el);

      this.coditionsSum =
        (el.source && el.source.outgoing && el.source.outgoing.length) || 0;

      this.initCurrentNodeFormData();
    },

    getCurrentConditonPriority(node) {
      if (node.type !== "bpmn:SequenceFlow") {
        return 0;
      }

      const {
        id,
        source: { outgoing },
      } = node;

      return outgoing ? outgoing.findIndex((item) => item.id === id) : 0;
    },

    initCurrentNodeFormData() {
      let document = this.currentEditNode.documentation;
      let initData = this.getApprovalInitFormData();

      if (document) {
        initData = JSON.parse(document[0].text).properties;
      }

      if (document && this.isShowNode("SequenceFlow")) {
        initData = JSON.parse(document[0].text);
      }

      let type = this.getCurrentNodeType(this.currentEditNode);

      this.$nextTick(() => {
        if (this.isShowApprovalNode()) {
          this.$refs["Approver"].initFormData(initData);
        } else {
          this.$refs[type].initFormData(initData);
        }
      });
    },

    getApprovalInitFormData() {
      const currentNodeType = this.getCurrentNodeType(this.currentEditNode);
      let approvalInitFormData = this.$js.deepClone(
        initNodeForm[currentNodeType] || {}
      );
      if (currentNodeType === "Finance") {
        approvalInitFormData.roleRange.push(this.getRolesByName("财务"));
      }
      if (currentNodeType === "Cashier") {
        approvalInitFormData.roleRange.push(this.getRolesByName("出纳"));
      }
      return approvalInitFormData;
    },

    /**
     *
     * 将表单数据转为bpmn数据
     */

    saveBpmnNodeData() {
      let type = this.getCurrentNodeType(this.currentEditNode);

      if (this.isShowApprovalNode()) {
        const approvalFormData = this.$refs["Approver"].approvalFormData;

        const toggle =
          approvalFormData.type === "presetEmployee" &&
          !approvalFormData.employeeRange.length;

        if (toggle) return this.$message.error("请至少选择一个人员进行审批！");

        const roleValidate =
          approvalFormData.type === "role" &&
          !approvalFormData.roleRange.length;

        if (roleValidate)
          return this.$message.error("请至少选择一个角色进行审批！");
      }

      if (this.isShowNode("SequenceFlow")) {
        const validate = this.$refs.SequenceFlow.validateForm();
        if (!validate) return;
      }

      this.passValidate();
    },

    passValidate() {
      this.saveCurrentNodeForm();
      this.showCurrentNodeText();
      this.formDrawerStatus = false;
    },

    saveCurrentNodeForm() {
      let type = this.getCurrentNodeType(this.currentEditNode);

      if (this.isShowApprovalNode()) {
        this.$refs["Approver"].clearBpmnSetting(this.currentEditNode);
        this.$refs["Approver"].createdBpmnSetting();
      } else {
        // 清空当前节点的xml标签
        this.$refs[type].clearBpmnSetting(this.currentEditNode);

        // 重新生成xml标签
        this.$refs[type].createdBpmnSetting();
      }

      // 设置document
      this.setCurrentNodeDocument(type);
    },

    setCurrentNodeDocument(type) {
      let documentObj = {};

      if (this.isShowApprovalNode()) {
        documentObj = this.$refs["Approver"].getDocument();
      } else {
        documentObj = this.$refs[type].getDocument();
      }

      let documentText = JSON.stringify({
        type: type.toLowerCase(),
        properties: documentObj,
      });

      if (this.isShowNode("SequenceFlow")) {
        documentText = JSON.stringify(documentObj);
      }

      this.createdBpmnTags(this.currentEditNode, documentText);
    },

    createdBpmnTags(bpmnNode, documentText) {
      var documentation = this.moddle.create("bpmn:Documentation");
      documentation.text = documentText;
      bpmnNode.set("documentation", []);
      bpmnNode.documentation.push(documentation);
    },

    showCurrentNodeText() {
      let showText = "";

      let type = this.getCurrentNodeType(this.currentEditNode);

      if (this.isShowNode("SequenceFlow")) {
        this.$refs["SequenceFlow"].setDocumentText();
        return;
      }

      if (this.isShowApprovalNode()) {
        showText = this.$refs["Approver"].getShowText();
      } else {
        showText = this.$refs[type].getShowText();
      }

      if (showText.length > 20) {
        showText = showText.slice(0, 20) + "...";
      }

      this.modeling.updateProperties(this.currentBpmnEl, { name: showText });
    },

    /**
     * other methods
     */

    // 根据id判断类型
    isTargetType(id, targetType) {
      return id.startsWith(targetType);
    },

    isShowNode(nodeType) {
      if (!(this.currentEditNode && this.currentEditNode.id)) {
        return false;
      }

      if (this.currentEditNode.id.startsWith("Flow")) {
        return nodeType === "SequenceFlow";
      }

      return this.currentEditNode.id.startsWith(nodeType);
    },

    getCurrentNodeType(node) {
      let type = node.id.slice(0, node.id.indexOf("_"));
      return type === "Flow" ? "SequenceFlow" : type;
    },

    isShowApprovalNode() {
      return (
        this.isShowNode("Approver") ||
        this.isShowNode("Finance") ||
        this.isShowNode("Cashier")
      );
    },

    // 获取雇员id集合
    getEmployeesId(employees) {
      return employees.map((item) => item.id).join(",");
    },

    //不同的节点执行不同的方法
    handleDifferentNodeAction(
      id,
      approverFn,
      financeFn,
      cashierFn,
      notifierFn,
      conditionFn
    ) {
      if (this.isTargetType(id, "Approver")) {
        approverFn();
      } else if (this.isTargetType(id, "Finance")) {
        financeFn();
      } else if (this.isTargetType(id, "Cashier")) {
        cashierFn();
      } else if (this.isTargetType(id, "Copy")) {
        notifierFn();
      } else if (this.isTargetType(id, "SequenceFlow")) {
        conditionFn();
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.approve-drawer_footer {
  text-align: right;
  line-height: 80px;
  padding: 0 40px 0 0;
  height: 80px;
  box-shadow: 0 1px 20px rgba(0, 21, 41, 0.08);
}

.from-content {
  overflow: auto;
  height: 100%;
  padding: 10px 0 0 25px;

  ::v-deep .__vuescroll {
    .__view {
      min-height: auto !important;
    }
  }
}
.approve-drawer_content {
  padding-right: 25px;
}

::v-deep .el-drawer__body {
  flex: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* padding-top: 10px; */
}
::v-deep .el-drawer {
  display: flex;
  flex-direction: column;
  width: 450px !important;
}
::v-deep .el-drawer__header {
  font-size: 14px;
  font-weight: 800;
  font-family: Helvetica;
  padding: 20px;
  margin: 0;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}
</style>
